'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _seekSeekClassificationsHierarchy = require('@seek/seek-classifications-hierarchy');

var _seekSeekClassificationsHierarchy2 = _interopRequireDefault(_seekSeekClassificationsHierarchy);

var classesBySubClass = {};

_seekSeekClassificationsHierarchy2['default'].forEach(function (classification) {
  classification.subClassifications.forEach(function (subClassification) {
    classesBySubClass[subClassification.id] = String(classification.id);
  });
});

exports['default'] = function (subClassId) {
  return classesBySubClass[subClassId] || null;
};

module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-jobs-seo/build/hierarchy/class-id-by-subclass-id.js
 ** module id = 543
 ** module chunks = 0
 **/